import api from "./axios";

// Admin-roster management: list admins, onboard a new one (the backend
// generates a username + one-time temp password), and toggle their status to
// block / re-enable logins on demand.
export const listAdmins = (params = {}) => api.get("/admins", { params });
export const createAdmin = (payload) => api.post("/admins", payload);
// Edit an admin's display name and/or login username.
export const updateAdmin = (id, payload) => api.patch(`/admins/${id}`, payload);
export const updateAdminStatus = (id, status) =>
  api.patch(`/admins/${id}/status`, { status });
// Issues a fresh one-time temp password and revokes their sessions.
export const resetAdminPassword = (id) => api.post(`/admins/${id}/reset-password`);
// Hard delete — also revokes any active sessions on the server.
export const deleteAdmin = (id) => api.delete(`/admins/${id}`);
